// extracted by mini-css-extract-plugin
module.exports = {"tokenInfoWrapper":"styles_tokenInfoWrapper__3QtsM","fieldsWrapper":"styles_fieldsWrapper__29_sI"};